/*var swiper = new Swiper('.swiper', {
  // Optional parameters
  slidesPerView: "auto",
  centeredSlides: true,
  //freeMode: true,
  spaceBetween: 20,
  loop: true,
  breakpoints: {
    750: {
      spaceBetween: 30
    }
  }
});



window.addEventListener('DOMContentLoaded', (event) => {
  swiper.slideToLoop(0);
});*/

var swiper = new Swiper('.swiper', {
  // Optional parameters
  slidesPerView: "auto",
  centeredSlides: true,
  //freeMode: true,
  spaceBetween: 20,
  loop: true,
  loopFillGroupWithBlank: true,
  breakpoints: {
    750: {
      spaceBetween: 30
    }
  }
});

window.addEventListener("load", function(event) {
  swiper.slideToLoop(0);
});